<!-- /components/admin/order-detail.vue -->
<template>
  <div class="order-detail">
    <!-- 订单基本信息 -->
    <div class="detail-section">
      <h4 >订单信息</h4>
      <el-descriptions :column="2" border>
        <el-descriptions-item label="订单号">
          <span class="order-no">{{ order.order_no }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="订单状态" style="text-align: center;">
          <el-tag :type="getStatusTagType(order.order_status)" style="margin-left: 80px;">
            {{ order.order_status_text }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="描述信息">
            {{ order.remark }}          
        </el-descriptions-item>
        <el-descriptions-item label="支付方式" >
          <a  style="padding-left: 80px;">{{ getPaymentMethodText(order.payment_method) }}</a>
        </el-descriptions-item>
        <el-descriptions-item label="创建时间">
          {{formatTime(order.created_at)}}
        </el-descriptions-item>
        <el-descriptions-item label="支付时间" v-if="order.payment_time">
          {{ formatTime(order.payment_time) }}
        </el-descriptions-item>
        <el-descriptions-item label="支付平台交易号" v-if="order.alipay_trade_no">
          {{ order.alipay_trade_no }}
        </el-descriptions-item>
      </el-descriptions>
    </div>
    
    <!-- 商品信息 -->
    <div class="detail-section">
      <h4>商品信息</h4>
      <el-table :data="orderItems" border>
        <el-table-column prop="item_name" label="商品名称" width="300">
          <template #default="{ row }">
            <div class="item-info">

              <span>{{ row.item_name }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="itemType" label="商品类型" width="100">
          <template #default="{ row }">
            <a style="margin-left: 30px;">{{ row.item_type === 1 ? '套餐' : '加油包' }}</a>
          </template>
        </el-table-column>
        <el-table-column prop="unit_price" label="单价" width="118">
          <template #default="{ row }">
            <a style="margin-left: 30px;">¥{{ formatPrice(row.unit_price) }}</a>
          </template>
        </el-table-column>
        <el-table-column prop="quantity" label="数量" width="100">
          <template #default="{ row }">
            <a style="margin-left: 30px;">×{{ row.quantity }}</a>
          </template>
        </el-table-column>
        <el-table-column label="小计" width="120">
          <template #default="{ row }">
            <span class="subtotal">¥{{ formatPrice(row.unit_price * row.quantity) }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    
    <!-- 价格信息 -->
    <div class="detail-section">
      <h4>价格信息</h4>
      <div class="price-summary">
        <div class="price-row">
          <span>商品总额：</span>
          <span class="price">¥{{ formatPrice(order.total_amount) }}</span>
        </div>
        <div class="price-row" v-if="order.discount_amount > 0">
          <span>优惠金额：</span>
          <span class="discount">-¥{{ formatPrice(order.discount_amount) }}</span>
        </div>
        <div class="price-row total">
          <span>实付金额：</span>
          <span class="total-amount">¥{{ formatPrice(order.payable_amount || order.total_amount - order.discount_amount) }}</span>
        </div>
      </div>
    </div>    

  </div>
</template>

<script>
import { formatToBeijingTime } from '@/util/date';
export default {  
  name: 'OrderDetail',
  props: {
    order: {
      type: Object,
      required: true
    }
  },
  computed: {
    orderItems() {
      return this.order.items || []
    }
  },
  mounted(){
    console.log(this.order);
  },
  methods: {
    formatTime(time){
      return formatToBeijingTime(time);
    },
    formatPrice(price) {
      if (!price && price !== 0) return '0.00'
      return parseFloat(price).toFixed(2)
    },
    
    getStatusText(status) {
      const statusMap = {
        0: '待支付',
        1: '已支付',
        2: '已完成',
        3: '已取消',
        4: '已过期'
      }
      return statusMap[status] || '未知状态'
    },
    
    getStatusTagType(status) {
      const typeMap = {
        0: 'warning',
        1: 'success',
        2: 'info',
        3: 'danger',
        4: 'info'
      }
      return typeMap[status] || 'info'
    },
    
    getOrderTypeText(type) {
      const typeMap = {
        1: '新购',
        2: '续费',
        3: '升级',
        4: '加油包'
      }
      return typeMap[type] || '未知类型'
    },
    
    getOrderTypeTagType(type) {
      const typeMap = {
        1: 'success',
        2: 'info',
        3: 'warning',
        4: 'info'
      }
      return typeMap[type] || 'info'
    },
    
    getPaymentMethodText(method) {
      const methodMap = {
        'alipay': '支付宝',
        'wechat': '微信支付',
        'balance': '余额支付'
      }
      return methodMap[method] || method || '未知方式'
    },
    
    handlePay() {
      this.$emit('pay', this.order)
    },
    
    handleCancel() {
      this.$emit('cancel', this.order)
    },
    
    handleRecreate() {
      this.$emit('recreate', this.order)
    }
  }
}
</script>

<style scoped>
.order-detail {
  padding: 0;
  margin-top: 0;
}

.detail-section {
  margin-bottom: 30px;
}

.detail-section h4 {
  margin-bottom: 5px;
   margin-top: -20px;
  color: #333;
  font-size: 12px;
  border-bottom: 1px solid #ebeef5;
  padding-bottom: 8px;
}

.order-no {
  font-family: monospace;
  font-weight: bold;
  color: #409eff;
}

.item-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.item-info i {
  color: #e6a23c;
}

.subtotal {
  font-weight: bold;
  color: #e4393c;
  text-align: center;
  margin-left: 30px;
}

.price-summary {
  padding: 20px;
  background: #f5f7fa;
  border-radius: 4px;
  max-width: 400px;
  margin: 0 auto 50px auto;

}

.price-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
  font-size: 14px;
  color: #666;
}

.price-row.total {
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid #dcdfe6;
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

.price {
  color: #e4393c;
  font-weight: 500;
}

.discount {
  color: #67c23a;
  font-weight: 500;
}

.total-amount {
  font-size: 18px;
  color: #e4393c;
  font-weight: bold;
}

.detail-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #ebeef5;
}
h4{
   margin: 0;
   font-size: 8pt;
   font-family: 微软雅黑;
}
</style>